import {
  
  ADD_POINTS,
  SET_TOTAL_POINTS,
  SET_LAST_EARNED_POINTS

} from './notificacionesTypes';

import { OBJECTIVES } from '../../constants/Gamification';
const initialState = {
  totalPoints: 0,
  lastEarnedPoints: 0,
  
};


export  function notificacionesReducers(state = initialState, action) {
  switch (action.type) {
    case ADD_POINTS:
      {
        const { type } = action.payload;
        const objective = OBJECTIVES[type];
        let newTotal = state.totalPoints;
        let lastEarnedPoints = state.lastEarnedPoints;

      if (objective) {
        // ✅ puntos base limitados al máximo
        lastEarnedPoints += objective.points
      }
      return {
        ...state,
        lastEarnedPoints: lastEarnedPoints, // Assuming you want to increment points
        totalPoints: newTotal
      };  
      }
    case SET_TOTAL_POINTS:
      return {
        ...state,
        totalPoints: action.payload,
      };  
    case SET_LAST_EARNED_POINTS:
      return {
        ...state,
        lastEarnedPoints: action.payload,
      };
    default:
      return state;
  }
}
